var map = {
	"./menu/alarm-config.png": 2265,
	"./menu/alarm-record.png": 6335,
	"./menu/api.png": 9318,
	"./menu/base-setting.png": 4908,
	"./menu/department.png": 4182,
	"./menu/icon_service_distribution.png": 630,
	"./menu/log.png": 1696,
	"./menu/menu.png": 6485,
	"./menu/more.png": 8347,
	"./menu/relation.png": 7352,
	"./menu/split-screen.png": 1569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;